var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 215.05 32.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.94 0 6.14 14.23 13.1 23.38 14.63 21.35 9.23 14.23 18.47 2.05 24.78 10.35 26.32 12.38 27.87 10.35 34.15 2.09 43.38 14.27 37.98 21.4 39.51 23.42 46.47 14.27 35.68 .04 32.62 .04 26.32 8.31 19.99 0 16.94 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -137.16,
    y1: 269.75,
    x2: -136.77,
    y2: 270.64,
    gradientTransform: "translate(5550.97 6337.32) scale(40.33 -23.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01f2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.73 .04 49.56 14.27 40.29 26.47 31.02 14.27 36.46 7.17 34.9 5.14 29.41 12.37 27.97 14.27 29.38 16.13 38.77 28.52 41.82 28.52 52.61 14.26 41.82 .04 38.73 .04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -136.41,
    y1: 271.78,
    x2: -136.41,
    y2: 271.78,
    gradientTransform: "translate(3361.77 7754.16) scale(24.64 -28.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.75 18.16 16.94 28.48 19.99 28.48 26.29 20.19 32.62 28.52 35.68 28.52 27.83 18.17 26.29 16.13 24.75 18.16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -134.38,
    y1: 261.74,
    x2: -134.37,
    y2: 261.74,
    gradientTransform: "translate(2517.72 3264.21) scale(18.74 -12.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.79 0 0 14.23 10.79 28.48 13.85 28.48 23.2 16.13 24.64 14.23 23.23 12.37 17.72 5.1 16.16 7.12 21.59 14.23 12.32 26.42 3.05 14.22 13.88 0 10.79 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -135.28,
    y1: 271.77,
    x2: -135.27,
    y2: 271.77,
    gradientTransform: "translate(3333.8 7753.84) scale(24.64 -28.48)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56385",
    "data-name": "Group 56385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41157",
    "data-name": "Group 41157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41156",
    "data-name": "Group 41156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41154",
    "data-name": "Group 41154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39396",
    "data-name": "Group 39396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79773",
    "data-name": "Path 79773",
    className: "cls-3",
    d: "M84.65,26.15l-.03-17.27-8.57,14.39h-1.56l-8.57-14.3v17.17h-3.25V2.44h2.78l9.89,16.66,9.75-16.66h2.78l.03,23.71h-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79774",
    "data-name": "Path 79774",
    className: "cls-3",
    d: "M107.08,15.31v10.84h-3.08v-2.37c-1.09,1.62-3.08,2.58-5.89,2.58-4.06,0-6.64-2.17-6.64-5.29,0-2.88,1.86-5.25,7.21-5.25h5.15v-.64c0-2.74-1.59-4.33-4.81-4.33-2.06-.02-4.07.66-5.69,1.93l-1.35-2.44c2.15-1.57,4.76-2.38,7.41-2.3,4.91,0,7.69,2.37,7.69,7.28M103.82,20.67v-2.51h-5.02c-3.22,0-4.13,1.26-4.13,2.78,0,1.79,1.49,2.91,3.96,2.91,2.23.16,4.32-1.12,5.18-3.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79775",
    "data-name": "Path 79775",
    className: "cls-3",
    d: "M128.45,15.81v10.33h-3.25v-9.96c0-3.52-1.76-5.25-4.85-5.25-3.45,0-5.69,2.07-5.69,5.96v9.25h-3.25V8.19h3.11v2.71c1.56-1.96,3.97-3.03,6.47-2.88,4.38,0,7.46,2.51,7.46,7.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79776",
    "data-name": "Path 79776",
    className: "cls-3",
    d: "M147.01,15.31v10.84h-3.08v-2.37c-1.09,1.62-3.08,2.58-5.89,2.58-4.06,0-6.64-2.17-6.64-5.29,0-2.88,1.86-5.25,7.21-5.25h5.15v-.64c0-2.74-1.59-4.33-4.81-4.33-2.06-.02-4.07.66-5.69,1.93l-1.35-2.44c2.15-1.57,4.76-2.38,7.41-2.3,4.91,0,7.69,2.37,7.69,7.28M143.75,20.67v-2.51h-5.02c-3.22,0-4.13,1.26-4.13,2.78,0,1.79,1.49,2.91,3.96,2.91,2.23.16,4.32-1.12,5.18-3.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79777",
    "data-name": "Path 79777",
    className: "cls-3",
    d: "M168.62,8.2v15.51c0,6.33-3.22,9.21-9.32,9.21-3.28,0-6.61-.92-8.57-2.68l1.56-2.51c1.97,1.54,4.41,2.37,6.91,2.34,4.23,0,6.17-1.96,6.17-6.03v-1.42c-1.63,1.85-4,2.87-6.47,2.78-5.18,0-9.11-3.52-9.11-8.7s3.93-8.67,9.11-8.67c2.55-.11,5.01.99,6.64,2.95v-2.78h3.08ZM165.43,16.7c0-3.49-2.58-5.82-6.17-5.82s-6.2,2.34-6.2,5.82,2.58,5.86,6.2,5.86c3.59,0,6.17-2.41,6.17-5.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79778",
    "data-name": "Path 79778",
    className: "cls-3",
    d: "M189.27,18.25h-14.56c.4,3.15,2.95,5.25,6.5,5.25,1.96.07,3.85-.72,5.18-2.17l1.79,2.1c-1.81,1.97-4.4,3.04-7.08,2.91-5.79,0-9.65-3.83-9.65-9.18-.2-4.85,3.58-8.94,8.43-9.14.19,0,.39,0,.58,0,5.18,0,8.87,3.73,8.87,9.25,0,.27-.04.67-.07.98M174.71,15.91h11.52c-.35-3.18-3.22-5.47-6.4-5.12-2.69.3-4.82,2.43-5.12,5.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79779",
    "data-name": "Path 79779",
    className: "cls-3",
    d: "M211.17,26.4l-7.11-9.79-7.01,9.79h-3.9l8.9-12.16-8.37-11.55h3.86l6.64,9.11,6.57-9.11h3.69l-8.37,11.45,8.97,12.26h-3.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41155",
    "data-name": "Group 41155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39951",
    "data-name": "Group 39951"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39950",
    "data-name": "Group 39950"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1210",
    "data-name": "Rectangle 1210",
    className: "cls-1",
    x: 6.14,
    width: 40.33,
    height: 23.42
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39953",
    "data-name": "Group 39953"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39952",
    "data-name": "Group 39952"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    className: "cls-4",
    x: 27.97,
    y: 0.04,
    width: 24.64,
    height: 28.48
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39955",
    "data-name": "Group 39955"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39954",
    "data-name": "Group 39954"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    className: "cls-5",
    x: 16.94,
    y: 16.13,
    width: 18.74,
    height: 12.39
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39957",
    "data-name": "Group 39957"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39956",
    "data-name": "Group 39956"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    className: "cls-6",
    width: 24.64,
    height: 28.48
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e5c40aac5d90f856f9fc5fcf34627650.svg";
export { ForwardRef as ReactComponent };